import {
  namespaces,
  useSharedTranslation,
} from 'us-react-components/dist/hooks/useSharedTranslation';
import { Sitter } from 'us-web-services';

interface Props {
  sitter: Sitter | null;
  activeTab: 'summary' | 'reviews' | 'calendar' | 'friends';
  viewerUserId?: number;
}

// Tab hrefs use plain <a> so they cross between React apps (families owns
// /friends) and AngularJS (summary + calendar still Angular-only).
export const SitterProfileChrome = ({
  sitter,
  activeTab,
  viewerUserId,
}: Props): JSX.Element => {
  const { t } = useSharedTranslation(namespaces.caregiver);
  if (!sitter?.id) return <></>;

  const sitterId = sitter.id;
  const isSelf = viewerUserId === sitterId;
  const q = typeof window !== 'undefined' ? window.location.search : '';

  const tabs: Array<{ key: 'summary' | 'reviews' | 'calendar' | 'friends'; href: string }> = [
    { key: 'summary', href: `/app/sitter/${sitterId}${q}` },
    { key: 'reviews', href: `/app/sitter/${sitterId}/reviews${q}` },
  ];
  if (!isSelf) {
    tabs.push({ key: 'calendar', href: `/app/sitter/${sitterId}/calendar${q}` });
  }
  tabs.push({ key: 'friends', href: `/app/sitter/${sitterId}/friends${q}` });

  return (
    <div className='mb-6'>
      <div className='flex items-center gap-4 mb-4'>
        {sitter.pictureUrl && (
          <img
            src={sitter.pictureUrl}
            alt={sitter.firstName ?? ''}
            className='w-20 h-20 rounded-full object-cover'
          />
        )}
        <h1 className='text-2xl font-semibold'>{sitter.name ?? sitter.firstName}</h1>
      </div>

      <ul id='profile-tabs' className='flex gap-6 border-b border-neutral-200 mb-5'>
        {tabs.map((tab) => (
          <a key={tab.key} href={tab.href}>
            <li
              className={`cursor-pointer pb-2 ${
                activeTab === tab.key
                  ? 'border-b-2 border-sapphire font-semibold text-sapphire'
                  : 'text-neutral-700'
              }`}
            >
              {t(`pages.sitterReviews.tabs.${tab.key}`)}
            </li>
          </a>
        ))}
      </ul>
    </div>
  );
};
